import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Heading } from '../../components/Heading';
import { GTMBaseContentViewObject, PageTracker } from '../../hooks/GTMUtils';
import { useAuth } from '../../hooks/useAuth';

export const Account: FC = () => {
  const { t } = useTranslation();
  const [{ user, auth }] = useAuth();

  return (
    <PageTracker
      gtmTrackingData={{
        ...GTMBaseContentViewObject,
        data: {
          category: 'User Area',
          type: 'Account Info',
          content: 'User Overview',
        },
      }}
    >
      <div className="xl:max-w-6xl">
        <div className="mx-8 md:mx-16 lg:ml-12">
          <div
            className="w-full my-12 md:mt-16 md:mb-16"
            data-test="page-header"
          >
            <Heading
              text={t('components:account:heading')}
              margin={0}
              level="h1"
            />
          </div>
          <div className="space-y-8 xl:max-w-6xl">
            <div className="w-full">
              <Heading level="h3" text={t('components:account:name')} />
              <div className="font-regular text-xl text-gray-700">{`${user?.first_name} ${user?.last_name}`}</div>
            </div>
            <div className="w-full">
              <Heading level="h3" text={t('components:account:email')} />
              <div className="font-regular text-xl text-gray-700">
                {auth?.email}
              </div>
            </div>
          </div>
        </div>
      </div>
    </PageTracker>
  );
};
